
import {ErrorsEnum} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/ErrorsEnum';

export const PageEnum = {
    SUBSCRIBERS: 'SUBSCRIBERS',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    LOADER: 'LOADER',
    CALLBACK: 'CALLBACK'
  };

export const CallsWizardErrorsEnum = {
 ...ErrorsEnum,
  // AMDOCS ISSUES
  ROAMING_BLOCKED_BY_AMDOCS_CALLS: 'ROAMING_BLOCKED_BY_AMDOCS_CALLS',
   // PACKAGE ISSUES
  ABROAD_PACKAGE_WITHOUT_CALLS: 'ABROAD_PACKAGE_WITHOUT_CALLS',
  ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION: 'ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION',
};




